// Doğrudan `axios` ile çağrı yapan eski editör sayfaları için oturum köprüsü.
//
// Uygulamanın büyük kısmı `src/api/api.js` içindeki paylaşılan istemciyi
// kullanıyor; o istemci hem çerezi (withCredentials) hem de Authorization
// başlığını gönderiyor. Ancak editor_pages altındaki eski ekranlar doğrudan
// `axios.post(...)` / `axios.patch(...)` çağırıyor ve varsayılan axios örneği
// ne çerez ne de jeton taşıyor.
//
// Bu, sunucudaki yazma uçları kimlik doğrulaması istemeye başlayınca (oyuncu
// ekleme/silme/birleştirme, kadro bağı yazma) o ekranların 401 almasına yol
// açardı. Aynı sorun zaten `PATCH /takimlar/:id` gibi önceden de korumalı olan
// uçlarda yaşanıyordu.
//
// Çözüm, on küsur dosyayı tek tek değiştirmek yerine varsayılan axios örneğine
// aynı oturum bilgisini eklemek. `axios.create()` ile üretilen örnekler kendi
// yapılandırmalarını taşıdığı için buradaki ayarlar paylaşılan istemciyi
// etkilemez.
import axios from "axios";
import api, { AUTH_TOKEN_KEY } from "./api";
import { ACTING_CITY_HEADER, actingCityHeaderValue } from "../utils/actingCity";

axios.defaults.withCredentials = true;

const readToken = () => {
  if (typeof window === "undefined") return "";
  const stored = localStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem("token");
  if (stored) return stored;
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.token || "";
  } catch {
    return "";
  }
};

// İl seçimi başlığı yalnız API sunucusuna gider; başka alan adlarına özel
// başlık gönderilirse tarayıcı CORS ön kontrolünde isteği düşürebilir.
const API_ORIGINS = new Set(
  [api.defaults.baseURL, "https://elitlig-api-88a866b7a4da.herokuapp.com/"]
    .map((url) => { try { return new URL(url).origin; } catch { return ""; } })
    .filter(Boolean)
);
const targetsApi = (url) => {
  if (!url || !/^https?:\/\//i.test(url)) return true;
  try { return API_ORIGINS.has(new URL(url).origin); } catch { return false; }
};

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (!config.headers.Authorization) {
    const token = readToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  if (!config.headers[ACTING_CITY_HEADER] && targetsApi(config.url)) {
    const actingCity = actingCityHeaderValue();
    if (actingCity) config.headers[ACTING_CITY_HEADER] = actingCity;
  }
  return config;
});

export default axios;
